"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var config_context_1 = require("../_util/config-context");
var use_resize_1 = require("../_util/use-resize");
var _chart_1 = require("../_chart");
var i18n_1 = require("../i18n");
/**
 * ChartBase 是所有图形组件底层组件，用以生成图表实例 chart，并负责所有 chart 的属性变更操作
 */
exports.ChartBase = react_1.forwardRef(function (props, chartRef) {
    var height = props.height, width = props.width, tips = props.tips, tipsStyle = props.tipsStyle, dataSource = props.dataSource, children = props.children;
    var container = react_1.useRef(null);
    var _a = tslib_1.__read(react_1.useState(null), 2), annotation = _a[0], setAnnotation = _a[1];
    var _b = tslib_1.__read(react_1.useState(null), 2), chart = _b[0], setChart = _b[1];
    var contextConfig = config_context_1.useConfig();
    var theme = Object.assign({}, contextConfig, props.theme);
    var classPrefix = theme.classPrefix;
    var t = i18n_1.useTranslation();
    react_1.useEffect(function () {
        if (!chartRef.current) {
            chartRef.current = new _chart_1.Chart(container.current, tslib_1.__assign({ height: height }, theme));
            setChart(chartRef.current);
            setAnnotation(chartRef.current.annotation());
        }
        return function () {
            chartRef.current.destroy();
        };
    }, [chartRef, height, theme, width]);
    react_1.useEffect(function () {
        if (chartRef.current) {
            chartRef.current.render();
        }
    }, [chartRef, height, width]);
    react_1.useEffect(function () {
        var e_1, _a;
        var dataSource = props.dataSource, color = props.color, scale = props.scale, _b = props.tooltip, tooltip = _b === void 0 ? true : _b, _c = props.legend, legend = _c === void 0 ? !!color : _c, selection = props.selection, zoom = props.zoom, interaction = props.interaction;
        // 即将废弃
        if (selection !== undefined) {
            console.error("[selection] 属性即将废弃，能力已迁移至 [interaction]");
            if (Array.isArray(interaction)) {
                interaction.push("brush");
            }
            else {
                interaction.brush = {};
            }
        }
        // 即将废弃
        if (zoom !== undefined) {
            console.error("[zoom] 属性即将废弃，能力已迁移至 [interaction]");
            if (Array.isArray(interaction)) {
                interaction.push("zoom");
            }
            else {
                interaction.zoom = { resetText: t.resetText };
            }
        }
        chartRef.current
            .theme(theme)
            .source(dataSource)
            .scale(scale)
            .tooltip(tooltip)
            .legend(legend);
        if (Array.isArray(interaction)) {
            try {
                for (var interaction_1 = tslib_1.__values(interaction), interaction_1_1 = interaction_1.next(); !interaction_1_1.done; interaction_1_1 = interaction_1.next()) {
                    var action = interaction_1_1.value;
                    if (action === "zoom") {
                        chartRef.current.interaction(action, { resetText: t.resetText });
                    }
                    else {
                        chartRef.current.interaction(action);
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (interaction_1_1 && !interaction_1_1.done && (_a = interaction_1.return)) _a.call(interaction_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        else if (typeof interaction === "object") {
            Object.keys(interaction).forEach(function (key) {
                chartRef.current.interaction(key, interaction[key]);
            });
        }
        // 为了配合 Annotation
        setTimeout(function () {
            chartRef.current.render();
        });
    }, [chartRef, props, t.resetText, theme]);
    use_resize_1.useResize(function () {
        chartRef.current.resize();
    });
    var showStatus = tips || !Array.isArray(dataSource) || dataSource.length === 0;
    return (react_1.default.createElement("div", { style: {
            position: "relative",
            width: width || "100%",
            height: height || "100%",
            fontSize: "14px",
        } },
        showStatus && (react_1.default.createElement("div", { className: classPrefix + "-chart-status", style: tslib_1.__assign({ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, textAlign: "center", lineHeight: height + "px", background: "#F8F8F8", zIndex: 9, width: width || "100%", height: height || "100%" }, tipsStyle) }, tips || t.noData)),
        react_1.default.createElement("div", { style: {
                width: width || "100%",
                height: height || "100%",
                position: "relative",
            }, ref: container }),
        react_1.default.Children.map(children, function (child) {
            return react_1.default.cloneElement(child, { chart: chart, annotation: annotation });
        })));
});
//# sourceMappingURL=Chart.js.map